module.exports = __webpack_public_path__ + "static/media/BannerD3.57034614.png";